import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface EditRecurringEventDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (editAll: boolean) => void;
  eventTitle?: string;
}

const EditRecurringEventDialog: React.FC<EditRecurringEventDialogProps> = ({
  open,
  onClose,
  onConfirm,
  eventTitle,
}) => {
  const { t } = useTranslation();
  const [editOption, setEditOption] = useState<'single' | 'all'>('single');

  const handleConfirm = () => {
    onConfirm(editOption === 'all');
    onClose();
  };

  const handleClose = () => {
    setEditOption('single'); // Reset al cerrar
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          //@ts-ignore
          backgroundColor: (theme) => theme.palette.background.panel,
        },
      }}
    >
      <DialogTitle>{t('calendar.editRecurringEvent', 'Editar evento recurrente')}</DialogTitle>

      <DialogContent>
        {eventTitle && (
          <Box sx={{ mb: 2, color: 'text.secondary', fontSize: '0.875rem' }}>"{eventTitle}"</Box>
        )}

        <FormControl component="fieldset" fullWidth>
          <RadioGroup
            value={editOption}
            onChange={(e) => setEditOption(e.target.value as 'single' | 'all')}
          >
            <FormControlLabel
              value="single"
              control={<Radio color="secondary" />}
              label={t('calendar.editThisEvent', 'Este evento')}
              sx={{ mb: 1 }}
            />
            <FormControlLabel
              value="all"
              control={<Radio color="secondary" />}
              label={t('calendar.editAllEvents', 'Todos los eventos')}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          color="inherit"
          sx={{ borderRadius: '8px' }}
        >
          {t('global.cancel', 'Cancelar')}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="secondary"
          sx={{ borderRadius: '8px' }}
        >
          {t('global.save', 'Guardar')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditRecurringEventDialog;
